import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_administration/employees")({
  beforeLoad: ({ context }) => guardRoute(context.me, "user-management"),
  component: Outlet,
});
